import { Component, OnInit, OnDestroy } from '@angular/core';
import {AppDataService} from "../../../services/app-data.service";
import {FormBuilder, FormGroup} from "@angular/forms";
import {CompanyService} from "../../../services/company.service";
import { TranslationService } from '../../../services/translation.service';


declare let $: any;
declare let Swal:any;

@Component({
    selector : 'unequip-action',
    templateUrl:'unequipAction.html'
})
export class unequipActionComponent implements OnInit{

  public itens;
  public media
  public linkForm: FormGroup;
  public onClickAction=false;
  public text=''

  public constructor(public translate: TranslationService,public _appData : AppDataService,private fb : FormBuilder, private _companyService : CompanyService) {
  }
  public saveData(){
    if (!this._appData.action){
      this._appData.action={kind:'removeItens',param:{}}
    }
    let itemArray=[]
    this.itens.forEach(it=>{
      if (it.selected){
        itemArray.push(it.objectId)
      }
    })
    this._appData.action.param.itens=itemArray
    document.getElementById('trigger-action-done').click();
  }
  public selectItem(it) {
    this.media=null
    for (let i = 0; i < this.itens.length; i++) {
      if (this.itens[i].objectId == it.objectId) {
        this.itens[i].selected= this.itens[i].selected ? false : true 
      }
    }



  }  
  public reload(){
    let action = this._appData.action;
    let trigger=this._appData.activeTrigger;
    this.itens=[]
    this._companyService.getUserRoomItemRef(this._appData.room.id).get().then(its=>{
      its.forEach(it=>{
        let item=it.data();
        item.selected=false;
        if (action.param.itens){
          action.param.itens.forEach(sit=>{
            if (sit==item.objectId){
              item.selected=true;
            }
          })
        }
        this.itens.push(item)
      })
    })
  }
    public ngOnInit(): any {


    }


}



// WEBPACK FOOTER //
// C:/prj/liveplanet-app-site/src/app/components/+gameevent/actions/unequipAction.ts